import repository from "../Repository";

export default {
  async create(screenId, payload) {
    return await repository.post(`disaster`, payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.patch(`disaster`, payload, {
      headers: {
        s: screenId
      }
    });
  }
};
